import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
import {environment} from '../../../environments/environment';
import {HttpRequestService} from '../../shared/services/http-request.service';
import {MemberStatusModel} from './application-management-popup.model';
import {GridService} from '../../shared/services/grid.service';

@Injectable()
export class ApplicantService extends GridService {
  private _memberPerStatusURL = environment.apiUrl + '/MemberCms/GetMembersPerStatus';
  private applicantsAnalyticsURL = environment.apiUrl + '/MemberCms/GetApplicantsAnalytics';
  private deleteApplicantURL = environment.apiUrl + '/MemberCms/Delete';
  private applicantInfoURL = environment.apiUrl + '/MemberCms/GetMemberById';
  private applicantFbDataInfoURL = environment.apiUrl + '/MemberCms/GetMemberFbDataById';
  private setStatusURL = environment.apiUrl + '/MemberCms/SetStatus';

  constructor(private _http: HttpRequestService) {
    super();
    this.getData = this.getApplicants;
  }

  getApplicants(data) {
    return this._http.post(this._memberPerStatusURL, data);
  }

  getApplicantsAnalytics() {
    return this._http.get(this.applicantsAnalyticsURL);
  }

  deleteApplicant(id: number) {
    return this._http.delete(this.deleteApplicantURL + '?memberId=' + id);
  }

  getUserInfo(id: number) {
    return this._http.get(this.applicantInfoURL + '?id=' + id);
  }

  getFbData(id: number) {
    return this._http.get(this.applicantFbDataInfoURL + '?id=' + id);
  }

  updateApplicantStatus(memberStatusModel: MemberStatusModel) {
    return this._http.post(this.setStatusURL, memberStatusModel);
  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/members/application-management/application-management.service.ts